module.exports = __webpack_public_path__ + "img/2.f3a708c4.jpg";